var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoSeats = function SvgNoSeats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 159,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1 112.9h10v32.6H62v-32.6z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 92h14.9v24.8h-15V91.9z",
    fill: "#CECECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 82h22.4v34.8H37.3V91.9a10 10 0 019.9-10z",
    fill: "#03AA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 92a10 10 0 019.9-10H32.3a10 10 0 00-10 10h15zM79.5 7.5h44.7a7.5 7.5 0 017.5 7.4v12.4H72V15a7.5 7.5 0 017.5-7.4zM131.7 37.3l-10 64.6H62.1l10-64.6h59.6z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 101.9h-10l10-64.6h10l-10 64.6z",
    fill: "#025D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27.3h49.7v10H77v-10z",
    fill: "#027B00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.8 37.3h-5l-6.5 42.2H80.5L87 37.3h-5l-10 64.6h5l1.2-7.5H103L102 102h5l1-7.5h1.4v-5h-.6l8-52.1zM78.9 89.4l.8-5h24.8l-.7 5H78.9z",
    fill: "#03AA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 109.3a7.5 7.5 0 007.5 7.5H22.4a7.5 7.5 0 010-15H82a7.5 7.5 0 00-7.5 7.5z",
    fill: "#038600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82 101.9h24.8v14.9H82a7.5 7.5 0 010-15z",
    fill: "#025D00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.6 27.3h-10V15a7.5 7.5 0 00-7.4-7.4h10a7.5 7.5 0 017.4 7.4v12.4z",
    fill: "#027B00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.7 27.3h10v10h-10v-10z",
    fill: "#025E00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87 7.5h29.8v24.8a5 5 0 01-5 5H91.9a5 5 0 01-5-5V7.5z",
    fill: "#03AA00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92h14.8v24.8H92V91.9z",
    fill: "#CECECE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.8 82H139v34.8h-32.3V91.9a10 10 0 0110-10z",
    fill: "#025D00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.8 92a10 10 0 0110-10h-15A10 10 0 0092 92h15z",
    fill: "#DEDEDE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 116.8v34.7H94.4a5 5 0 010-9.9h27.3v-24.8h10z",
    fill: "#C5C5C5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4 146.6a5 5 0 005 5H34.8a5 5 0 010-10h59.6a5 5 0 00-5 5z",
    fill: "#E3E3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.4 52.2c2.3 0 4.1 2 3.8 4.3l-2 12.8a3.8 3.8 0 01-3.7 3.2H63c-2.4 0-4.2-2-3.8-4.4l2-12.7a3.8 3.8 0 013.7-3.2h51.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 56.4l-1.9 12.8a3.2 3.2 0 01-3.1 2.7H63c-2 0-3.5-1.8-3.2-3.7l2-12.7a3.2 3.2 0 013-2.7h51.6c2 0 3.4 1.7 3.1 3.6z",
    stroke: "#EB5757",
    strokeWidth: 1.3
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69 62.9h-1l-.3 2.3h-1.3l1.1-6.2h2c.7 0 1.2.2 1.6.5.4.3.5.8.5 1.3 0 .9-.5 1.5-1.4 1.8l1 2.5h-1.4L69 63zm-.8-1h1c.3 0 .6-.1.8-.3.2-.1.3-.4.4-.7 0-.2 0-.5-.2-.6-.1-.2-.3-.3-.6-.3h-1l-.4 1.9zm8.5.6h-2.4L74 64h2.8l-.2 1h-4l1-6h4l-.1 1h-2.8l-.2 1.4h2.3l-.1 1zm4.8 1c0-.3 0-.6-.5-.8l-.8-.3c-1-.4-1.4-1-1.3-1.7 0-.4.1-.7.3-1l.9-.6a3 3 0 011.2-.2c.6 0 1 .2 1.4.6.4.3.6.8.6 1.3H82c0-.3 0-.5-.2-.6-.1-.2-.3-.3-.6-.3s-.5 0-.7.2c-.2.2-.4.3-.4.6s.2.5.6.7l.6.2.3.2c.8.4 1.2 1 1.2 1.7 0 .4-.2.7-.4 1a2 2 0 01-.8.5 3 3 0 01-2.4 0 1.8 1.8 0 01-1-1.8h1.3c0 .7.2 1 1 1 .2 0 .5 0 .7-.2.2 0 .3-.3.3-.5zm6.7-1h-2.4l-.3 1.6h2.8l-.2 1h-4l1-6h4v1h-2.8l-.3 1.4h2.4l-.2 1zm4.1.4h-1l-.4 2.3h-1.2l1-6.2h2c.7 0 1.3.2 1.6.5.4.3.6.8.5 1.3 0 .9-.5 1.5-1.3 1.8l.8 2.5H93l-.7-2.2zm-.8-1h.9c.3 0 .6-.1.8-.3.2-.1.3-.4.4-.7l-.1-.6c-.2-.2-.4-.3-.7-.3h-1l-.3 1.9zm6.7 1.7l2-4.6h1.5l-3 6.2h-1.3L96.3 59h1.3l.6 4.6zm8-1.1h-2.4l-.3 1.6h2.7l-.1 1h-4l1-6h4l-.2 1h-2.7l-.3 1.4h2.4l-.2 1zm1.4 2.7l1-6.2h1.8c.4 0 .8.1 1.1.3.4.2.6.4.9.8.2.3.3.7.3 1v1.1c-.1.9-.5 1.6-1 2.1a3 3 0 01-2.2.9h-1.9zm2.1-5.2l-.7 4.1h.5c.6 0 1-.2 1.4-.6.3-.4.5-1 .6-1.9v-.1c0-.5 0-.8-.3-1-.2-.3-.4-.5-.8-.5h-.7z",
    fill: "#EB5757"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M152.1 112.9h10v32.6h-10v-32.6z",
    fill: "#C5C5C5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M112.4 92h14.9v24.8h-15V91.9z",
    fill: "#CECECE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.2 82h22.4v34.8h-32.3V91.9a10 10 0 019.9-10z",
    fill: "#03AA00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 92a10 10 0 019.9-10h-14.9a10 10 0 00-10 10h15zM169.5 7.5h44.7a7.5 7.5 0 017.5 7.4v12.4H162V15a7.5 7.5 0 017.5-7.4zM221.7 37.3l-10 64.6h-59.6l10-64.6h59.6z",
    fill: "#DEDEDE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M221.7 101.9h-10l10-64.6h10l-10 64.6z",
    fill: "#025D00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167 27.3h49.7v10H167v-10z",
    fill: "#027B00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8 37.3h-5l-6.5 42.2h-24.8l6.5-42.2h-5l-10 64.6h5l1.2-7.5H193L192 102h5l1-7.5h1.4v-5h-.6l8-52.1zm-37.9 52.1l.8-5h24.8l-.7 5h-24.9z",
    fill: "#03AA00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 109.3a7.5 7.5 0 007.5 7.5h-59.6a7.5 7.5 0 010-15H172a7.5 7.5 0 00-7.5 7.5z",
    fill: "#038600"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M172 101.9h24.8v14.9H172a7.5 7.5 0 010-15z",
    fill: "#025D00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.6 27.3h-10V15a7.5 7.5 0 00-7.4-7.4h10a7.5 7.5 0 017.4 7.4v12.4z",
    fill: "#027B00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216.7 27.3h10v10h-10v-10z",
    fill: "#025E00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177 7.5h29.8v24.8a5 5 0 01-5 5h-19.9a5 5 0 01-5-5V7.5z",
    fill: "#03AA00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M182 92h14.8v24.8H182V91.9z",
    fill: "#CECECE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8 82H229v34.8h-32.3V91.9a10 10 0 0110-10z",
    fill: "#025D00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M196.8 92a10 10 0 0110-10h-15a10 10 0 00-9.9 10h15z",
    fill: "#DEDEDE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.7 116.8v34.7h-37.3a5 5 0 010-9.9h27.3v-24.8h10z",
    fill: "#C5C5C5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M179.4 146.6a5 5 0 005 5h-59.6a5 5 0 010-10h59.6a5 5 0 00-5 5z",
    fill: "#E3E3E3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.4 52.2c2.3 0 4.1 2 3.8 4.3l-2 12.8a3.8 3.8 0 01-3.7 3.2H153c-2.4 0-4.2-2-3.8-4.4l2-12.7a3.8 3.8 0 013.7-3.2h51.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 56.4l-1.9 12.8a3.2 3.2 0 01-3.1 2.7H153c-2 0-3.5-1.8-3.2-3.7l2-12.7a3.2 3.2 0 013-2.7h51.6c2 0 3.4 1.7 3.1 3.6z",
    stroke: "#EB5757",
    strokeWidth: 1.3
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159 62.9h-1l-.3 2.3h-1.3l1.1-6.2h2c.7 0 1.2.2 1.6.5.4.3.5.8.5 1.3 0 .9-.5 1.5-1.4 1.8l1 2.5h-1.4L159 63zm-.8-1h1c.3 0 .6-.1.8-.3.2-.1.3-.4.4-.7 0-.2 0-.5-.2-.6-.1-.2-.3-.3-.6-.3h-1l-.4 1.9zm8.5.6h-2.4L164 64h2.8l-.2 1h-4l1-6h4l-.1 1h-2.8l-.2 1.4h2.3l-.1 1zm4.8 1c0-.3 0-.6-.5-.8l-.8-.3c-1-.4-1.4-1-1.3-1.7 0-.4.1-.7.3-1l.9-.6a3 3 0 011.2-.2c.6 0 1 .2 1.4.6.4.3.6.8.6 1.3H172c0-.3 0-.5-.2-.6 0-.2-.3-.3-.6-.3s-.5 0-.7.2c-.2.2-.4.3-.4.6s.2.5.6.7l.6.2.3.2c.8.4 1.2 1 1.2 1.7 0 .4-.2.7-.4 1a2 2 0 01-.8.5 3 3 0 01-2.4 0 1.8 1.8 0 01-1-1.8h1.3c0 .7.2 1 1 1 .2 0 .5 0 .7-.2.2 0 .3-.3.3-.5zm6.7-1h-2.4l-.3 1.6h2.8l-.2 1h-4l1-6h4v1h-2.8l-.3 1.4h2.4l-.2 1zm4.1.4h-1l-.4 2.3h-1.2l1-6.2h2c.7 0 1.3.2 1.6.5.4.3.6.8.5 1.3 0 .9-.5 1.5-1.3 1.8l.8 2.5H183l-.7-2.2zm-.8-1h.9c.3 0 .6-.1.8-.3.2-.1.3-.4.4-.7 0-.2 0-.5-.2-.6 0-.2-.3-.3-.6-.3h-1l-.3 1.9zm6.7 1.7l2-4.6h1.5l-3 6.2h-1.3l-1.1-6.2h1.3l.6 4.6zm8-1.1h-2.4l-.3 1.6h2.7l-.1 1h-4l1-6h4l-.2 1h-2.7l-.3 1.4h2.4l-.2 1zm1.4 2.7l1-6.2h1.8c.4 0 .8.1 1.1.3.4.2.6.4.9.8.2.3.3.7.3 1v1.1c-.1.9-.5 1.6-1 2.1a3 3 0 01-2.2.9h-1.9zm2.1-5.2l-.7 4.1h.5c.6 0 1-.2 1.4-.6.3-.4.5-1 .6-1.9v-.1c0-.5 0-.8-.3-1-.2-.3-.4-.5-.8-.5h-.7z",
    fill: "#EB5757"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 54,
    y: 52.2,
    width: 71.3,
    height: 30.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 144,
    y: 52.2,
    width: 71.3,
    height: 30.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoSeats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-seats.51438573.svg";
export { ForwardRef as ReactComponent };